import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars} from "@fortawesome/free-solid-svg-icons";
import AuthContext from "../../Context/AuthContext";
import ajaxUser from "../../util/remote/ajaxUser";
import toast from "react-hot-toast";
import AdminDropdown from "./AdminDropdown";


export const headerData = {
  logo: "/assets/img/buzz.png",
  user: {
    name: "Steven Zone",
    role: "Admin",
    profileImg: "/assets/img/figure/admin.jpg",
  },
  messages: [
    {
      id: 1,
      sender: "Maria Zaman",
      time: "18:30",
      message: "What is the reason of buy this item. Is it useful for me...",
      img: "/assets/img/figure/student11.png",
    },
    {
      id: 2,
      sender: "Benny Roy",
      time: "10:35",
      message: "What is the reason of buy this item. Is it useful for me...",
      img: "/assets/img/figure/student12.png",
    },
    {
      id: 3,
      sender: "Steven",
      time: "02:35",
      message: "What is the reason of buy this item. Is it useful for me...",
      img: "/assets/img/figure/student13.png",
    },
  ],
  notifications: [
    {
      id: 1,
      icon: "fas fa-check",
      message: "Complete Today Task",
      time: "1 Mins ago",
      color: "bg-skyblue",
    },
    {
      id: 2,
      icon: "fas fa-calendar-alt",
      message: "Director Meeting",
      time: "20 Mins ago",
      color: "bg-orange",
    },
    {
      id: 3,
      icon: "fas fa-cogs",
      message: "Update Password",
      time: "45 Mins ago",
      color: "bg-violet-blue",
    },
  ],
  languages: [
    { code: "EN", name: "English" },
    { code: "ES", name: "Spanish" },
    { code: "FR", name: "French" },
    { code: "CN", name: "Chinese" },
  ],
};



const Header = ({toggler, isSidebarOpen, toggleMobileHeader, mobileHeaderIsOpen}) => {

  const {user, userId} = useContext(AuthContext);
  const [openMobileAdmin, setOpenMobileAdmin] = useState(false);  

  const navigate = useNavigate();

  const handleLogout = async (e) => {

    e.preventDefault();
    const server_response = await ajaxUser.logoutUser(userId);
    if (server_response.status === "OK") {
      localStorage.removeItem("buzzMe@user");
      navigate("/login");
      window.location.reload();
    } 
    else{
      toast.error(server_response.message); 
    }
  };

  const toggleMobileAdmin = () => {
    setOpenMobileAdmin(!openMobileAdmin);
  }


  return (
    <div className="navbar navbar-expand-md header-menu-one bg-light">
      <div className="nav-bar-header-one">
        {/* Logo */}
        <div className="header-logo">
          <Link to="/">
            <img src={headerData.logo} alt="logo"  style={{width: '40px'}}/><span style={{color:"white"}}>BUZZ TIME</span>
          </Link>
        </div>

        {/* Sidebar Toggle */}
        <div className="toggle-button sidebar-toggle">
          <button type="button" className="item-link"onClick={toggler} >
            <span className="btn-icon-wrap">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
      </div>

      {/* Mobile Navbar */} 
      <div className="d-md-none mobile-nav-bar">
        <button className={`navbar-toggler pulse-animation ${openMobileAdmin ? '' : 'collapsed'}`} type="button" data-toggle="collapse" data-target="#mobile-navbar" aria-expanded={openMobileAdmin ? "true" : "false"} onClick={toggleMobileAdmin}>
          <i class="far fa-arrow-alt-circle-down"></i>
          </button>
          <button className="navbar-toggler sidebar-toggle-mobile" type="button" data-toggle="collapse" data-target="#mobile-navbar" onClick={toggleMobileHeader}>
            <FontAwesomeIcon icon={faBars} />
          </button>
      </div>

      {/* Header Main Menu */}
      <div className={`header-main-menu collapse navbar-collapse ${openMobileAdmin ? 'show': ''}`} id="mobile-navbar">
        <ul className="navbar-nav">
          {/* Search Bar */}
          <li className="navbar-item header-search-bar">
            <div className="input-group stylish-input-group">
              <span className="input-group-addon">
                <button type="submit">
                  <span className="flaticon-search" aria-hidden="true" ></span>
                </button>
              </span>
              <input type="text" className="form-control" placeholder="Find Something . . ." />
            </div>
          </li>
        </ul>

        <ul className="navbar-nav">
          {/* Admin Profile */}
          <AdminDropdown user={user} handleLogout={handleLogout}/>

          {/* Message & Notification Dropdowns */}
          {/* <Dropdown icon={faEnvelope} title="Messages" items={headerData.messages} type="messages" />
          <Dropdown icon={faBell} title="Notifications" items={headerData.notifications} type="notifications" />

          <li className="navbar-item dropdown header-language">
            <a className="navbar-nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown">
              <FontAwesomeIcon icon={faGlobeAmericas} /> EN
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              {headerData.languages.map((lang) => (
                <a key={lang.code} className="dropdown-item" href="#">{lang.name}</a>
              ))}
            </div>
          </li> */}
         


        </ul>
      </div>
    </div>
  );
};

export default Header;
